import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { trustResourceUrl } from "@shared/helpers/SafeUrlHelper";

@Component({
    selector: "my-video-widget-wrapper",
    templateUrl: "../fullpage-iframe/fullpage-iframe.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["../fullpage-iframe/fullpage-iframe.component.scss"]
})
export class VideoWidgetWrapperComponent {
    public embedUrl: SafeUrl = null;

    constructor(activatedRoute: ActivatedRoute, sanitizer: DomSanitizer) {
        const params: any = activatedRoute.snapshot.queryParams;
        this.embedUrl = trustResourceUrl(sanitizer, params.url);
    }
}
